import { CargoManagementQuery } from '../../../../../../services/query';
import { OrderCommand } from '../../../../../../services/command';

const normalizeAddressForCard = (address: any) => {
    if (!address) {
        return address;
    }

    const phone = (address.combinedPhoneNumber ?? address.phoneNumber ?? '').toString();

    return {
        ...address,
        phoneNumber: address.phoneNumber ?? phone,
        combinedPhoneNumber: phone,
        floorName: address.floorName ?? address.floor,
        flatName: address.flatName ?? address.flat,
    };
};

export const fetchOrderInformation = async (orderId: any) => {
    const response = await OrderCommand.GetOrderInformation({
        CustomerId: Number(orderId.customerId),
        OrderNumber: String(orderId.orderNumber),
        CultureCode: localStorage.getItem('lan') || 'tr-TR',
        MobileVersionCode: '',
        BackofficeTypeId: 2,
    });

    if (!response) {
        return null;
    }
    if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        return {
            ...response,
            ...response.data,
        };
    }

    return response;
};

export const mapOrderRecipientToAddressModels = (orderInformation: any) => {
    const recipientDetail = orderInformation?.orderRecipientDetail;
    if (!recipientDetail) {
        return null;
    }

    const shippingAddress = normalizeAddressForCard(recipientDetail.shippingAddress);
    const billingAddress = normalizeAddressForCard(recipientDetail.billingAddress);

    if (shippingAddress && shippingAddress.deliveryMethodId == null && recipientDetail.deliveryMethodId != null) {
        shippingAddress.deliveryMethodId = recipientDetail.deliveryMethodId;
    }

    if (!shippingAddress && !billingAddress) {
        return null;
    }

    return {
        saleOrderShippingAddressModel: shippingAddress,
        saleOrderBillingAddressModel: billingAddress,
    };
};

export const fetchSaleOrderShippingBillingAddress = async (orderId: any) => {
    const orderInformation = await fetchOrderInformation(orderId);
    return mapOrderRecipientToAddressModels(orderInformation);
};

export const fetchCountryAddressRules = async () => {
    const response = await CargoManagementQuery.CountryAddressRulesforCountryId();
    return response.data.countryAddressRules;
};

export const fetchMobileCountryAddressRules = async (deliveryMethodId: number) => {
    const response = await CargoManagementQuery.MobileCountryAddressRule({ deliveryMethodId });
    return response.data.addressRules ?? [];
};
